import { render, staticRenderFns } from "./ProductListAddNew.vue?vue&type=template&id=550721fa&"
import script from "./ProductListAddNew.vue?vue&type=script&lang=js&"
export * from "./ProductListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./ProductListAddNew.vue?vue&type=style&index=0&id=550721fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports